import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { UserService } from "src/app/user/user.service";

@Component({
    selector: 'cij-forgot-password-dialog',
    templateUrl: 'forgot-password-dialog.component.html',
    styleUrls: ['forgot-password-dialog.component.css']
})
export class ForgotPasswordDialogComponent {

    status: String;

    form = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email])
    });

    constructor(public dialogRef: MatDialogRef<ForgotPasswordDialogComponent>, public snackBar: MatSnackBar, public userService: UserService) {

    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    async onSubmit() {
        let result = this.form.get('email').value;

        if (result) {
            try {
                let response = await this.userService.sendForgotPassword(result).toPromise();
                if (response) {
                    this.snackBar.open(`Er is een e-mail verzonden naar ${result} met informatie over het veranderen van het wachtwoord.`, 'OK', {
                        duration: 2000
                    });
                    this.dialogRef.close();
                }
                else {
                    this.status = 'Er is een fout opgetreden, controleer of het e-mail adres bestaat en probeer het opnieuw.';
                }
            }
            catch (err)
            {
                console.log(err);
                this.status = err?.error?.message || 'Er is een fout opgetreden, controleer of het e-mail adres bestaat en probeer het opnieuw.';
            }
            
        }


    }

}